import { useEffect, useState } from "react"
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux"
import { YearDDLAPI } from "../../../helper/Redux/Slices/DDLSlice/DDLSlice"
import { useAuthState } from "../../../helper/Context/context"


export const FinancialYear = (props) => {
    const { FinancialYearID, setFinancialYearID } = props

    const userDetails = useAuthState();
    const { year, setYear, CurrentYear } = userDetails
    const { UserID, token } = userDetails.user

    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token
        }
        dispatch(YearDDLAPI({ data }))
    }, [])

    const { DDLData } = useSelector(state => state.YearDDLData)

    useEffect(() => {
        handleYearDDL()
    }, [DDLData])

    const handleYearDDL = () => {
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_FinancialYearID,
                label: item.financialYear
            }))
            const currentYearOption = list.find((option) =>
                String(option.label) === String(CurrentYear) || String(option.label).startsWith(`${CurrentYear}-`)
            ) || list[0]
            const selectedYear = year.ID ? { value: year.ID, label: year.Label } : currentYearOption

            setFinancialYearID({
                DDL: list,
                ID: selectedYear?.value || 0,
                Label: selectedYear?.label || "Year..."
            })
            if (!year.ID && currentYearOption) {
                setYear({ ...year, ID: currentYearOption.value, Label: currentYearOption.label })
            }
        }
        else {
            setFinancialYearID({
                DDL: [],
                ID: 0,
                Label: "Year...",
            })
        }
    }

    const handleChangeYear = (e) => {
        setFinancialYearID({ ...FinancialYearID, ID: e.value, Label: e.label })
        setYear({ ...year, ID: e.value, Label: e.label })
    }

    const handleClearYear = (e) => {
        setFinancialYearID({ ...FinancialYearID, ID: 0, Label: "Year..." })
        setYear({ ...year, ID: 0, Label: "0" })
    }

    return (
        <>
            <div className="d-flex align-items-center" style={{ marginTop: '-2px' }}>
                <Select
                    isClearable
                    id='DDLID'
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused ? 'transparent' : 'transparent',
                            // borderBottomColor: 'purple',
                            borderColor: 'white',
                            boxShadow: 'none',
                            maxWidth: '150px'
                        }),
                    }}
                    isSearchable
                    maxMenuHeight={150}
                    value={{ value: FinancialYearID.ID, label: FinancialYearID.Label }}
                    onChange={(e) => {
                        e ?
                            handleChangeYear(e)

                            :
                            handleClearYear(e)

                    }}
                    options={FinancialYearID.DDL}
                />
            </div>






        </>
    )
}